// cherry pick lodash methods
var _ = require('lodash');
var flatten = require('flat');

const Validation = {};

Validation.install = function(Vue, options)
{
    let _watchers = {}; // container for watchers
    let _messages = {}; // temporary storage for error messages

    /*
     * Unwatch registered watchers
     */
    let _unwatch = function()
    {
        // unwatch previous watchers
        _.forIn(_watchers, function(unwatch)
        {
            unwatch();
        });
    }

    /*
     * Validators
     *
     * Place all validators in here. Use them in the $rules section of the
     * component.
     */
    let _validators =
    {
        required: function(val)
        {
            if (typeof val === 'array') return val.length !== 0;
            else if (typeof val === 'object') return Object.keys(val).length !== 0;
            else return (val === '' || val === null) ? false : true;
        },

        /*
         * @param val
         * @param args, array containing keys for from and until
         */
        overnight: function(val, args)
        {
            if (args.length != 2)
            {
                console.error("Entries missing in args: " + args);
                return false;
            }

            return (parseInt(val[args[0]]) < parseInt(val[args[1]]) || parseInt(val[args[1]]) == 0);
        },

        /*
         * @param val
         * @param args, value from first validation field to check
         */
        repeat: function(val, args, vm)
        {
            if (vm[args[0]][args[1]]) return val.localeCompare(vm[args[0]][args[1]]) != -1;

            console.error("Can't find value to compare at: ", args[0], args[1]);
            return false;
        },

        numeric: function(val)
        {
            return ! isNaN(parseFloat(val)) && isFinite(val);
        },
    }

    Vue.mixin(
    {
        data() {
            return {
                $errors: {}, // validation errors
            }
        },

        beforeCreate()
        {
            let vm = this;

            this.$v =
            {
                /**
                 * Check if form field has error
                 *
                 * @param {String} key
                 * @return {Boolean}
                 */
                hasError(key)
                {
                    return !!_.at(vm.$data.$errors, key)[0];
                },

                /**
                 * Returns error message
                 *
                 * @param {String} key
                 * @return {String}
                 */
                message(key)
                {
                    return (this.hasError(key)) ? this.getError(key) : '';
                },

                getError(key)
                {
                    return (typeof _.at(vm.$data.$errors, key)[0] === 'string') ? _.at(vm.$data.$errors, key)[0] : _.at(vm.$data.$errors, key)[0][0];
                },

                isValid(namespace)
                {
                    let errors = (namespace) ? vm.$data.$errors[namespace] : vm.$data.$errors;

                    if ( ! errors) return true;

                    let _errors = flatten(errors);

                    let total = 0, count = 0;
                    _.forOwn(_errors, (value, key) => {
                        total++;
                        if (_errors[key] === null) count++;
                    });

                    return total === count;
                },

                resetErrors()
                {
                    vm.$data.$errors = {};
                },

                /**
                 * Validate form field
                 *
                 * @param {String} key
                 * @param {Mixed} val
                 */
                validate(key, val)
                {
                    let rules = _.get(vm.$data.$rules, key, false);

                    // field has no rules
                    if (rules === false) return true;

                    rules = rules.split('|');

                    let matched = 0,
                        total = rules.length;

                    rules.forEach(function(rule)
                    {
                        let args = rule.match(/\((.*?)\)/);

                        if (args)
                        {
                            let _rule = rule.split('(')[0],
                                _args = args[1].split(',');

                            if (_rule in _validators)
                            {
                                for (let i in _args)
                                {
                                    _args[i] = _.trim(_args[i]);
                                }

                                if (_validators[_rule](val, _args, vm)) matched++;
                                    return;
                            }
                        }
                        else
                        {
                            if (rule in _validators)
                            {
                                if (_validators[rule](val)) matched++;
                                   return;
                            }
                        }

                        console.info('Validation rule [' + rule + '] is not defined.');
                    });

                    return matched == total;
                },

                /**
                 * Set errors object
                 *
                 * Error object does not have to be namespaced, if multiple forms
                 * are being used in the $data.form object.
                 *
                 * @param {Object} errors
                 * @param {String} namespace
                 */
                setErrors(errors, namespace)
                {
                    // unwatch all previous watchers
                    _unwatch();

                    _.forIn(errors, function(val, key)
                    {
                        // add namespace to key, if it's set
                        key = (namespace) ? namespace + '.' + key : key;

                        // register watchers for invalid form fields
                        _watchers[key] = vm.$watch('form.' + key, function(val)
                        {
                            if (vm.$v.validate(key, val))
                            {
                                // get the error message
                                let error = _.get(vm.$data.$errors, key);

                                // temporary store the error message
                                if (error) _.set(_messages, key, error);

                                // remove the error upon form field change
                                _.set(vm.$data.$errors, key, null);

                                // teardown watcher
                                // _watchers[key]();
                            }
                            else
                            {
                                // get the stored error message
                                let error = _.get(_messages, key);

                                // re-set the error
                                if (error)
                                {
                                    _.set(vm.$data.$errors, key, error);
                                }
                            }
                        }, {
                            deep: true,
                        });
                    });

                    // Transform laravel errors to deep object
                    let _errors = _.transform(errors, function(transformed, val, key)
                    {
                        _.set(transformed, key, val);
                    });

                    // set reactive error object
                    if (namespace)
                    {
                        Vue.set(vm.$data.$errors, namespace, _errors);
                        return;
                    }

                    // else...
                    vm.$data.$errors = _errors;
                },
            }
        },

        beforeDestroy()
        {
            // unwatch all watchers
            _unwatch();
        },
    })
};

export default Validation;



// WEBPACK FOOTER //
// ./src/js/plugins/validation.js